import { useContext, useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import MiniInfoButton from "src/components/MiniInfoButton";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { FiEye } from "react-icons/fi";
import { TbReload } from "react-icons/tb";
import { get } from "src/services/HttpClient";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import Modal from "src/components/Modal/Modal";
import { LuPackageSearch } from "react-icons/lu";
import TwinButton from "src/components/TwinButton";
import { notify } from "src/services/Notification/Notification";
import InboundSingle from "./components/InboundSingle";
import { put } from "src/services/HttpClient/HttpClient";
import { TbEyeSearch } from "react-icons/tb";



var moment = require("jalali-moment");

export default function SellerRefund() {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [sellerComment, setSellerComment] = useState("")
    const [viewInboundModalOpen, setViewInboundModalOpen] = useState(false);
    const [selectedInbound, setSelectedInbound] = useState(null)
    const [selectedRefundProducts, setSelectedRefundProducts] = useState(null);

    const updateInbound = async () => {
        setSellerComment("")
        let missedItem = selectedRefundProducts.find((item) => parseInt(item.delivaryQuantity) != parseInt(item.refundQuantity))

        try {
            const payload = {
                sellerComment,
                status: missedItem ? "partial" : "delivered",
                products: selectedRefundProducts.map(product => {
                    return {
                        ...product,
                        deliveredQuantity: product.delivaryQuantity,
                    }
                })
            };

            const result = await put(`/seller/refunds/${selectedInbound.id}`, payload);

            if (result && result.success) {
                notify("محموله با موفقیت بروزرسانی شد", "success");
                getData(setData, "/seller/refunds")
                setModalOpen(false);
            } else {
                notify(result?.message || "خطا در ایجاد محموله", "error");
            }
        } catch (error) {
            notify("خطا در ارتباط با سرور", "error");
        }
    }


    useEffect(() => {
        getData(setData, "/seller/refunds")
    }, []);



    useEffect(() => {
        if (selectedInbound && selectedInbound?.refundproducts && selectedInbound?.refundproducts.length) {
            setSelectedRefundProducts(selectedInbound.refundproducts.map((row) => ({
                ...row,
                delivaryQuantity: row?.refundQuantity,
            })));
        }
    }, [selectedInbound])

    const getStatusColor = (status) => {
        switch (status) {
            case "pending":
                return "#facc15";
            case "delivered":
                return "#22c55e";
            case "partial":
                return "#d54a3b";
            case "cancelled":
                return "#ef4444";
            default:
                return "#6b7280";
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case "pending":
                return "در انتظار";
            case "delivered":
                return "تحویل شده";
            case "partial":
                return "کسری دارد";
            case "cancelled":
                return "لغو شده";
            default:
                return "نامشخص";
        }
    };

    // const handleChange = (e) => {
    //     let count = e.target.value
    //     if (count > product?.totalQuantity) {
    //         notify("تعداد تحویل نمیتواند بزرگتر از تعداد محموله باشد", "error")
    //         count = 0;
    //     }
    //     setInbound(prev => {
    //         return prev.map((product, innerIndex) => {
    //             if (innerIndex == index) {
    //                 return {
    //                     ...product,
    //                     delivaryQuantity: count
    //                 }
    //             } else {
    //                 return {
    //                     ...product
    //                 }
    //             }
    //         })

    //     })
    // }

    const columns = [
        {
            id: "id",
            cell: (info) => info.getValue(),
            header: "شناسه",
        },
        {
            id: "status",
            cell: (info) => (
                <MiniInfoButton
                    text={getStatusText(info.getValue())}
                    backgroundColor={getStatusColor(info.getValue())}
                />
            ),
            header: "وضعیت",
        },
        {
            id: "createdAt",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue())
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            header: "تاریخ ایجاد",
        },
        {
            id: "deliveredAt",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue())
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            header: "تاریخ تحویل",
        },
        {
            id: "warehouseComment",
            cell: (info) => info.getValue(),
            header: "توضیحات انباردار",
        },
        {
            id: "sellerComment",
            cell: (info) => info.getValue(),
            header: "توضیحات تامین کننده",
        },
        {
            id: "totalInboundQuantity",
            cell: (info) => {
                const products = info.row.original.refundproducts;
                if (!products) return 0;
                return products.reduce((sum, product) => sum + (product.refundQuantity || 0), 0);
            },
            header: "مجموع تعداد محموله",
        },
        {
            id: "totalDeliveredQuantity",
            cell: (info) => {
                const products = info.row.original.refundproducts;
                if (!products) return 0;
                return products.reduce((sum, product) => sum + (product.deliveredQuantity || 0), 0);
            },
            header: "مجموع تعداد تحویل",
        },
        {
            id: "actions",
            cell: (info) => (
                <div className="flex gap-2">
                    {
                        info.row.original.deliveredAt
                            ?
                            <div
                                className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                                onClick={() => {
                                    setSelectedRefundProducts(info.row.original.refundproducts);
                                    setSelectedInbound(info.row.original)
                                    setViewInboundModalOpen(true);
                                }}
                                title="مشاهده جزئیات"
                            >
                                <TbEyeSearch className="text-green-500" />
                            </div>
                            :
                            <div
                                className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                                onClick={() => {
                                    setSelectedRefundProducts(info.row.original.refundproducts);
                                    setSelectedInbound(info.row.original)
                                    setModalOpen(true);
                                }}
                                title="ویرایش"
                            >
                                <LuPackageSearch className="text-blue-500" />
                            </div>
                    }
                </div>
            ),
            header: "عملیات",
            enableColumnFilter: false,
        },
    ];


    return (
        <>
            <PageHeader
                title="مدیریت مرجوعی ها"
                // btnTitle="بروزرسانی"
                // handleClick={getInboundData}
                // isBtnLoading={loading}
                // btnIcon={<TbReload className="ml-1" size="22" />}
            />
            <Table
                columns={columns}
                data={data}
                CSVExportPermission="exportSellerInbound"
                tableName="seller-refund"
            />
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} width={900}>
                <ModalHeader toggle={() => setModalOpen(false)}>
                    جزییات محصولات ورودی
                </ModalHeader>
                <ModalBody>
                    <div className="p-4">
                        {selectedRefundProducts && selectedRefundProducts.length > 0 ? (
                            <div className="flex flex-col gap-2">
                                {selectedRefundProducts && selectedRefundProducts.map((product, idx) => (
                                    <InboundSingle
                                        index={idx}
                                        product={product}
                                        setInbound={setSelectedRefundProducts}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-8">محصولی وجود ندارد.</div>
                        )}
                        <div className="flex flex-col gap-4 mt-4">
                            <div className="flex flex-col gap-4">
                                {
                                    selectedInbound?.sellerComment
                                    &&
                                    <div className="flex flex-col gap-2">
                                        <span>توضیحات فروشنده</span>
                                        <p className="bg-gray-50 p-2 rounded-xl">
                                            {selectedInbound?.sellerComment}
                                        </p>
                                    </div>
                                }
                            </div>
                            <div className="flex flex-col gap-1">
                                <label htmlFor="">توضیحات تامین کننده</label>
                                <textarea className="rounded-xl p-2 bg-white border border-gray-200" name="" id="" value={sellerComment} onChange={(e) => { setSellerComment(e.target.value) }}>اگر توضیحات خاصی مد نظرتان هست در این قسمت وارد کنید</textarea>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        isCompact
                        rejectHandle={() => { setModalOpen(false); setSellerComment("") }}
                        acceptHandle={updateInbound}
                    />
                </ModalFooter>
            </Modal>



            <Modal isOpen={viewInboundModalOpen} toggle={() => setViewInboundModalOpen(false)} width={900}>
                <ModalHeader toggle={() => setViewInboundModalOpen(false)}>
                    جزییات مرسوله
                </ModalHeader>
                <ModalBody>
                    <div className="p-4">
                        {selectedRefundProducts && selectedRefundProducts && selectedRefundProducts.length > 0 ? (
                            <div className="flex flex-col gap-[10px]">
                                {selectedRefundProducts.map((product, idx) => (
                                    <div key={idx} className={`${parseInt(product.deliveredQuantity ?? 0) < parseInt(product.refundQuantity ?? 0) ? "!bg-red-100" : ""} flex flex-col md:flex-row items-center gap-4 border border-gray-200 rounded-lg p-2`}>
                                        <img
                                            className="w-[70px] h-[70px] object-cover rounded-lg border border-gray-100"
                                            src={product.image}
                                            alt={product.name}
                                        />
                                        <div className="flex-1 flex flex-col gap-1">
                                            <div className="flex flex-col flex-wrap gap-3">
                                                <span className="font-semibold text-sm">{product.name}</span>
                                                <div className="flex gap-4">
                                                    <span className="text-xs text-gray-500">SKU: {product.sku}</span>
                                                    <span className="text-xs text-gray-500">شماره سفارش: {product.orderId}</span>
                                                </div>

                                            </div>
                                            <div className="flex flex-wrap gap-4 mt-2">
                                                <span className="text-xs text-gray-600">تعداد مرجوعی: <b>{product.refundQuantity}</b></span>
                                                <span className="text-xs text-gray-600">تعداد تحویل: <b>{product.deliveredQuantity ?? 0}</b></span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-8">محصولی وجود ندارد.</div>
                        )}
                        <div className="flex flex-col gap-4 mt-4">
                            {
                                selectedInbound?.warehouseComment
                                &&
                                <div className="flex flex-col gap-2">
                                    <span>توضیحات فروشنده</span>
                                    <p className="bg-gray-50 p-2 rounded-xl">
                                        {selectedInbound?.warehouseComment}
                                    </p>
                                </div>
                            }
                            {
                                selectedInbound?.sellerComment
                                &&
                                <div className="flex flex-col gap-2">
                                    <span>توضیحات انباردار</span>
                                    <p className="bg-gray-50 p-2 rounded-xl">
                                        {selectedInbound?.sellerComment}
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}
